module.exports = __webpack_public_path__ + "media/images/image-placeholder-9270c3e6.png";